/* eslint-disable max-len */
const React = require('react');

const HomeFooterStatusPage = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
    <path fill="#000" fillOpacity=".8" fillRule="nonzero" d="M17.8 16.594v1.2H2.2v-1.2h15.6zm0-2.99v1.2H2.2v-1.2h15.6zm0-3.015v1.2H2.2v-1.2h15.6zm0-8.394v6.597H2.2V2.195h15.6zm-1.2 1.2H3.4v4.197h13.2V3.395z" />
  </svg>
);

module.exports = HomeFooterStatusPage;
